export default __webpack_public_path__ + "assets/fonts/1eb80cac8e7301df097f3171e355da00.woff";